import { Link } from 'react-router-dom';
import { getImageUrl } from '../utils/imageUrl';

const BookCard = ({ book }) => {
  const coverUrl = getImageUrl(book.cover);
  
  return (
    <div className="group bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-300">
      <Link to={`/books/${book._id}`} className="block">
        <div className="relative aspect-[3/4] overflow-hidden rounded-t-2xl bg-gray-100">
          {coverUrl ? (
            <img
              src={coverUrl}
              alt={book.title}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-dark-blue-100 to-dark-blue-200">
              <svg className="w-16 h-16 text-dark-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
            </div>
          )}
          <div className="absolute top-3 left-3 flex flex-col gap-2 max-w-[80%]">
            <span className="px-3 py-1 bg-dark-blue-700/90 text-white text-xs font-medium rounded-full backdrop-blur-sm truncate">
              {book.category}
            </span>
            <span className="px-3 py-1 bg-white/90 text-gray-800 text-xs font-medium rounded-full backdrop-blur-sm w-fit">
              {book.publishedYear}
            </span>
          </div>
        </div>
        <div className="p-5">
          <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2 group-hover:text-dark-blue-700 transition-colors">{book.title}</h3>
          <p className="text-gray-600 text-sm mb-1">Oleh: {book.author}</p>
          <p className="text-gray-500 text-xs mb-1">ISBN: {book.isbn}</p>
          <p className="text-dark-blue-700 font-semibold text-lg mb-4">
            Rp {book.price?.toLocaleString('id-ID') || 0}
          </p>
          <div className="block text-center py-2 text-dark-blue-700 font-medium border border-dark-blue-700 rounded-xl hover:bg-dark-blue-50 transition-colors">
            Baca Selengkapnya
          </div>
        </div>
      </Link>
    </div>
  );
};

export default BookCard;
